<template>
    <label :for="inputId" class="edit_input">
        {{ name }}

        <Datepicker v-if="type === 'date'" :id="inputId" :locale="$i18n.locale === 'ru' ? ru : enUS"
            :format="date => date?.toLocaleDateString('enUS')" :model-value="modelValue"
            @update:model-value="value => emit('update:modelValue', value)" dropdown-class="date_picker"
            :typeable="false" inputFormat="dd.MM.yyyy" :placeholder="placeholder" />

        <input v-else :id="inputId" :type="type" :placeholder="placeholder" :value="modelValue" name="edit_input"
            @input="event => emit('update:modelValue', event.target.value)" :class="{ 'error': props.error }">
    </label>
</template>

<script setup>
import { computed } from 'vue'
import Datepicker from 'vue3-datepicker'
import { ru, enUS } from 'date-fns/locale'

const props = defineProps({
    placeholder: {
        type: String,
        required: false,
    },
    error: {
        type: [String, Object],
        required: false,
    },
    type: {
        type: String,
        default: "text",
    },
    name: {
        type: String,
    },
    modelValue: {
        type: [String, Date, null],
        default: "",
    },
})

const hasError = computed(() => {
    if (props.error) return true
})

const inputId = `input-${Math.random().toString(36).substr(2, 9)}`
const emit = defineEmits(["update:modelValue"])
</script>

<style>
.v3dp__popout {
    background: var(--vdp-bg-color) !important;
    border-radius: 12px !important;
    width: 100% !important;
    height: 100% !important;
}

.v3dp__body {
    background: var(--vdp-bg-color) !important;
    border-radius: 12px !important;
    padding: 10px !important;
}

.v3dp__heading__center:hover {
    background: var(--hover) !important;
}

.v3dp__heading__button:hover {
    background: var(--hover) !important;
}

.date_picker .datepicker-day:hover {
    background: var(--hover) !important;
}

.selected span {
    background: var(--main-color) !important;
    color: rgba(51, 51, 51, 1) !important;
}

.v3dp__elements {
    padding: 0 !important;
    gap: 5px !important;
    margin: 5px 0 !important;
    cursor: pointer !important;
}

.v3dp__element__button__day:hover {
    background: transparent !important;
}

.v3dp__element__button__day span:hover {
    background: var(--main-color) !important;
    color: rgba(51, 51, 51, 1) !important;
}

.dp__cell_inner:hover {
    background: var(--main-color) !important;
    color: rgba(51, 51, 51, 1) !important;
}

.edit_input {
    display: flex;
    font-size: 0.9rem;
    gap: 0.4rem;
    box-sizing: border-box;
    justify-content: flex-end;
    align-items: center;
    position: relative;
}

.edit_input input {
    background-color: var(--text-hover-color);
    border-radius: 15px;
    padding: 0.8rem 1rem;
    color: var(--text-color);
    font-size: 0.95rem;
    width: 300px;
}

.edit_input input[type="date"] {
    cursor: pointer;
}

.edit_input input[type='date']::-webkit-calendar-picker-indicator {
    cursor: pointer;
}

.edit_input input::-webkit-calendar-picker-indicator {
    opacity: 0.7;
}

.input_error {
    color: #ff6b6b;
    font-size: 13px;
    margin-top: 4px;
}

.error {
    border: 1px solid #c44;
}
</style>
